<template>
    <div class="card__buttons">
        <wrapper :break-column="breakColumn" :center="center" :left="left" :right="right" :grow="grow" :stretch="stretch" :between="between">
            <slot/>
        </wrapper>
    </div>
</template>

<script>
import Alignable from "../../mixins/Alignable";

    export default {
        name: "CardButtons",
        mixins: [Alignable],

        props: {
            // The column name on which to break the content
            breakColumn: {
                type: String,
                default: null
            },

            // Whether to align the items with 'justify-between'
            between: {
                type: Boolean,
                default: false
            },

            // Whether the content shall take the full parent's width up to a max width of 300px for each item
            grow: {
                type: Boolean,
                default: false
            },

            // Whether the content shall take the full parent's width without an individual width limit
            stretch: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style>
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.card .card__buttons {
  padding: 0 24px 12px;
}
@media (max-width: 1023px) {
  .card .card__buttons {
    padding: 0 16px 8px;
  }
}
.card.is-tight .card__buttons {
  padding: 5px;
}
</style>